import { storage } from "@/firebase";

async function uploadImageToStorage(path, file) {
  // eslint-disable-next-line
  return new Promise(async (resolve, reject) => {
    await storage.ref(path).put(file).then(async r => {
      r.ref.getDownloadURL().then(url => {
        resolve({
          success: true,
          url: url
        })
      }).catch(e => {
        resolve({
          success: false,
          msg: e.message
        })
      })
    }).catch(e => {
      resolve({
        success: false,
        msg: e.message
      })
    })
  })
}

async function uploadPreviewImageToStorage(path, file, preview) {
  // eslint-disable-next-line
  return new Promise(async (resolve, reject) => {
    await storage.ref(path).child(file + "-p").putString(preview, "base64", { contentType: "image/ jpg" }).then(async r => {
      r.ref.getDownloadURL().then(url => {
        resolve({
          success: true,
          url: url
        })
      }).catch(e => {
        resolve({
          success: false,
          msg: e.message
        })
      })
    }).catch(e => {
      resolve({
        success: false,
        msg: e.message
      })
    })
  })
}

export {
  uploadImageToStorage,
  uploadPreviewImageToStorage
};
